import { randomRPCTesnet } from 'utils/helpers';

export const POLLING_INTERVAL = 10000;

export const TOKEN_ADDRESS = process.env.REACT_APP_TOKEN_ADDRESS;

export const DECIMAL_SCALE = 2;

export const TYPE_OF_ANT_DESIGN = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  IMG_DONE: 'done',
};

export const ROUND_DETAIL = {
  SEED_ROUND: {
    title: 'SEED ROUND',
    type: 1,
  },
  PRIVATE_1_ROUND: {
    title: 'PRIVATE 1 ROUND',
    type: 2,
  },
  PRIVATE_2_ROUND: {
    title: 'PRIVATE 2 ROUND',
    type: 3,
  },
  STRATEGIC_ROUND: {
    title: 'STRATEGIC ROUND',
    type: 4,
  },
  LAUNCHPAD_ROUND: {
    title: 'LAUNCHPAD ROUND',
    type: 5,
  },
  TEST_ROUND: {
    title: 'TEST ROUND',
    type: 6,
  },
  KUCOIN_ROUND: {
    title: 'KUCOIN ROUND',
    type: 7,
  },
  WHITE_LIST: {
    title: 'WHITELIST ROUND',
    type: 8
  }
};

export const FORMAT_DATE_NORMAl = 'DD/MM/YYYY'

const LIST_BSC_TESTNET = [
  'https://data-seed-prebsc-1-s1.binance.org:8545/',
  'https://data-seed-prebsc-2-s1.binance.org:8545/',
  'https://data-seed-prebsc-1-s2.binance.org:8545/',
  'https://data-seed-prebsc-2-s2.binance.org:8545/',
  'https://data-seed-prebsc-1-s3.binance.org:8545/',
  'https://data-seed-prebsc-2-s3.binance.org:8545/',
];

export const LIST_NETWORK_RPC_TESTNET: any = {
  97: randomRPCTesnet(LIST_BSC_TESTNET),
  80001: 'https://rpc-mumbai.maticvigil.com/',
  4: 'https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
};

export const LIST_NETWORK_RPC_MAINNET: any = {
  56: 'https://bsc-dataseed.binance.org/',
  137: 'https://rpc-mainnet.maticvigil.com/',
  1: 'https://mainnet.infura.io/v3/50f6131e95134c0fba1a009b561a31d9',
};

export const NETWORK_CHAIN_ID = {
  BSC_TEST: 97,
  BSC: 56,
};

export const METAMASK_DEEPLINK = 'https://metamask.io/download';
export const BRIDGE_URL = 'https://pancakeswap.bridge.walletconnect.org';
export const NETWORK_URL_BSC = 'https://bsc-dataseed.binance.org/';

//Screen size breakpoint
export const BREAKPOINT_MOBILE_MAX = 575;
export const BREAKPOINT_TABLET_MAX = 767;
